import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
// import clsx from 'clsx';
import _ from 'lodash';

import { useTheme, makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle'; // substituted by custom
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import Avatar from '@material-ui/core/Avatar';

import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { Radar } from 'react-chartjs-2';

import DialogTitle from 'components/DialogTitle';
import DimensionSlider from '../components/DimensionSlider';
import { loadPositionDimension, savePositionDimension } from '../store/positionDimensions.slice';
import { openDialog, closeDialog } from '../store/discuss.slice';
// import ThinkingImage from 'icons/Thinking';
import FeedbackIcon from 'icons/Feedback';
import LikeIcon from 'icons/Like';
import ThumbsIcon from 'icons/Thumbs';

const useStyles = makeStyles(theme => ({
  root: {
    // border: 'solid black 1px', // DEBUG
    display: 'flex',
  },
    label: {
      fontSize: 14,
      fontWeight: 400,
      textAlign: 'center',
      lineHeight: '32px',
      margin: '0px 5px',
    },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  trigger: {
    backgroundColor: theme.palette.tertiary.main,
    padding: '0px 5px',
    // height: 'inherit',
    height: 18,
    // fontSize: 14,
    textTransform: 'none',
    // color: 'inherit',
    color: 'white',
    '& span span span': { height: 16 },
  },
  recap: {
    // border: 'solid black 1px', // DEBUG
    marginTop: -5,
    marginBottom: 15,
  },
}));

const maxSteps = 2;
const lastStep = maxSteps - 1;

function getTitle(step) {
  switch(step) {
    case 0: return 'Do you agree that';
    case 1: return 'Reflections feedback';
    default:
      return ''; // @todo error
  }
};

const defaultLevels = {
  polarized: 50,
  unclear: 50,
  unpolarized: 50,
  agree: 50,
};

const radarOptions = {
  scale: {
    ticks: {
      suggestedMin: 0,
      suggestedMax: 100,
      // stepSize: 1
    }
  }
};

const radarLabels = [
  'This is a very polarized position',
  'It is unclear if I can trust this',
  'This should be prioritized',
  'Most people would agree with this',
];

// @note we need this function because the sorting is not garantee
function toArray(values) {
  // console.log('Position.toArray(values)', values); // DEBUG
  return [
    _.get(values, 'polarized', 0),
    _.get(values, 'unclear', 0),
    _.get(values, 'unpolarized', 0),
    _.get(values, 'agree', 0),
  ];
}

function meDataset(values) {
  return {
    label: 'Me',
    backgroundColor: 'rgba(60,103,188,0.2)',
    borderColor: 'rgba(60,103,188,1)',
    pointBackgroundColor: 'rgba(60,103,188,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(60,103,188,1)',
    borderWidth: 1,
    // data: _.values(values),
    data: toArray(values),
  };
};

function groupDataset(values) {
  return {
    label: 'Group Average',
    backgroundColor: 'rgba(255,192,46,0.2)',
    borderColor: 'rgba(255,192,46,1)',
    pointBackgroundColor: 'rgba(255,192,46,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(255,192,46,1)',
    borderWidth: 1,
    // data: _.values(values),
    data: toArray(values),
  };
};

function PositionDimensionsCast(props) {
  const {
    position,
    variant,
    pending,
    // error,
    openDialog,
    votingUsers,
    dimensions,
    averages,
    authUser,
    onLoad,
    onSave,
    onClose,
  } = props;
  const theme = useTheme();
  const classes = useStyles();
  const [draft, setDraft] = useState(false);
  const [levels, setLevels] = useState(defaultLevels);
  const [activeStep, setActiveStep] = useState(0);

  const handleSlide = name => (event, value) => {
    // console.log('PositionDimensionsCast.handleSlide', name, value); // DEBUG
    event.preventDefault();
    setLevels({ ...levels, [name]: value });
    setDraft(true);
  }

  const handleSave = (event) => {
    // console.log('CastPositionDimensions.handleSave', levels); // DEBUG
    event.preventDefault();
    onSave(levels);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // const buildTrigger = () => (
  //   <Button
  //     className={classes.trigger}
  //     variant="contained"
  //     color="secondary"
  //     size="small"
  //     startIcon={<ThinkingImage />}
  //     aria-label="Open position cognitive dimensions"
  //     onClick={onLoad}
  //   >
  //     Reflect
  //   </Button>
  // );

  const buildTrigger = () => (
    <Tooltip title="People who reflected on this" placement="top" arrow>
      <IconButton
        size="small"
        // aria-label="Open position cognitive dimensions"
        onClick={onLoad}
      >
        {/* <ThumbsIcon /> */}
        <LikeIcon />
        {/* <LikeIcon variant={variant} /> */}
        {/* <FeedbackIcon variant={variant} /> */}
      </IconButton>
    </Tooltip>
  );

  const buildFirstStep = () => (
    <div className={classes.commands}>
      <DimensionSlider
        variant="Primary"
        label={<>This is a very <strong>polarized</strong> position</>}
        name={`position-cd-polarized-${position.id}`}
        value={levels.polarized}
        onChange={handleSlide('polarized')}
      />
      <DimensionSlider
        variant="Primary"
        label={<>It is <strong>unclear</strong> if I can <strong>trust</strong> this</>}
        name={`position-cd-unclear-${position.id}`}
        value={levels.unclear}
        onChange={handleSlide('unclear')}
      />
      <DimensionSlider
        variant="Secondary"
        label={<>This should be <strong>prioritized</strong></>}
        name={`position-cd-unpolarized-${position.id}`}
        value={levels.unpolarized}
        onChange={handleSlide('unpolarized')}
      />
      <DimensionSlider
        variant="Secondary"
        label={<>Most people would <strong>agree</strong> with this</>}
        name={`position-cd-agree-${position.id}`}
        value={levels.agree}
        onChange={handleSlide('agree')}
      />
    </div>
  );

  const buildSecondStep = () => (<>
    <div className={classes.recap}>
      &laquo;{position.text}&raquo;
    </div>
    <div className={classes.radar}>
      <Radar
        options={radarOptions}
        data={{
          labels: radarLabels,
          datasets: [
            meDataset(levels),
            groupDataset(averages),
          ],
        }}
      />
    </div>
  </>);

  const buildStepper = () => (
    <MobileStepper
      style={{ width: '100%' }}
      variant="dots"
      steps={maxSteps}
      position="static"
      activeStep={activeStep}
      className={classes.root}
      backButton={
        <Button size="small" disabled={activeStep === 0} onClick={handleBack}>
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          Back
        </Button>
      }
      nextButton={
        activeStep < maxSteps - 1
          ? <Button size="small" onClick={handleNext}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          : <EndButton save={draft} />
      }
    />
  );

  const EndButton = memo(({ save }) => {
    return (
      <div>
        {dimensions &&
          <Button variant="outlined" color="primary" size="small"
            onClick={() => { setActiveStep(0) }}
          >Rethink it through</Button>
        }
        &nbsp;
        {dimensions === null || save
          ? <Button variant="contained" color="primary" size="small"
              disabled={activeStep === maxSteps} startIcon={<SaveIcon />}
              onClick={handleSave}
            >Save</Button>
          : <Button variant="contained" color="primary" size="small"
              disabled={activeStep === maxSteps}
              onClick={onClose}
            >Close</Button>
        }
      </div>
    );
  });

  useEffect(() => {
    if (!pending && dimensions !== null) {
      setLevels(dimensions);
      setDraft(false);
      setActiveStep(lastStep);
    }
  }, [pending, dimensions]);

  useEffect(() => {
    if (!Boolean(authUser)) {
      setActiveStep(lastStep);
    }
  }, [authUser]);

  // console.log('PositionDimensionsCast', props); // DEBUG

  return (
    <>
    {/* <div className={classes.root}> */}
      <div className={classes.root}>
        <div className={classes.button}>{buildTrigger()}</div>
        <div className={classes.label}>{votingUsers}</div>
      </div>
      <Dialog
        open={openDialog}
        // maxWidth="md"
        fullWidth={true}
        onClose={onClose}
      >
        <DialogTitle onClose={onClose}>{getTitle(activeStep)}</DialogTitle>
        <DialogContent>
          {activeStep === 0 && buildFirstStep()}
          {activeStep === 1 && buildSecondStep()}
        </DialogContent>
        <DialogActions>
          {Boolean(authUser)
            ? buildStepper()
            : <Button variant="contained" color="primary" size="small"
                onClick={onClose}
              >Close</Button>
          }
        </DialogActions>
      </Dialog>
    {/* </div> */}
    </>
  );
}

const mapStateToProps = (state, ownProps) => {
  const positionId = ownProps.position.id;
  const dialogState = state.discuss.layout.dialogs;
  const dimentionsState = state.discuss.positionDimensions;
  const selected = _.get(dimentionsState, `byId[${positionId}]`, null);
  return {
    openDialog: dialogState.positionDimensions === positionId,
    pending: _.get(selected, 'pending', false),
    error: _.get(selected, 'error', null),
    votingUsers: _.get(selected, 'votingUsers', 0),
    dimensions: _.get(selected, 'data', null),
    averages: _.get(selected, 'averages', null),
    authUser: state.auth.profile,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const position = ownProps.position;
  return {
    onSave: values => {
      const entry = {
        debateId: position.debateId,
        positionId: position.id,
        levels: values,
      };
      return dispatch(savePositionDimension(entry))
        .then(res => {
          if (res.meta.requestStatus === 'fulfilled') {
            dispatch(closeDialog('positionDimensions'));
          }
          return res;
        });
    },
    onLoad: () => {
      return dispatch(loadPositionDimension(position))
        .then(res => {
          // console.log('PositionDimensionsCast.onLoad()', res) // DEBUG
          dispatch(openDialog({
            resourceName: 'positionDimensions',
            resourceId: position.id,
          }));
          return res;
        });
    },
    onClose: () => dispatch(closeDialog('positionDimensions')),
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionDimensionsCast);
